import styled from "styled-components";
import { rem, em } from "convert-to-ems";

export const FooterContainer = styled.div.withConfig({ displayName: "FooterContainer" })`
  background-color: #010000;
  display: flex;
  width: 100%;
  height: 7rem;
  align-items: center;
  text-align: center;
  flex-direction: row;

  @media ${props => props.theme.breakpoints.smallHomeScreen} {
    height: 100%;
    flex-direction: column;
  }
  @media ${props => props.theme.breakpoints.largeHomeScreen} {
    height: 100%;
    flex-direction: column;
  }
`;

export const FooterContainerFirstBlock = styled.div.withConfig({
  displayName: "FooterContainerFirstBlock",
})`
  display: flex;
  width: 60%;
  height: 5rem;
  align-items: center;
  justify-content: flex-end;
  padding-left: ${rem(10)};
  padding-right: ${rem(40)};
  flex-direction: row;
  border-right: 1px solid rgba(255, 255, 255, 0.3);

  @media ${props => props.theme.breakpoints.smallHomeScreen} {
    width: 100%;
    height: 8rem;
    flex-direction: column;
    align-items: center;
    padding: ${rem(20)};
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  @media ${props => props.theme.breakpoints.largeHomeScreen} {
    width: 100%;
    height: 8rem;
    flex-direction: column;
    align-items: center;
    padding: ${rem(20)};
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  p {
    height: ${rem(48)};
    width: ${rem(130)};
    color: ${props => props.theme.baseColor};
    font-size: ${em(20)};
    padding-right: ${rem(20)};
    text-align: start;
    font-weight: bold;
    line-height: ${rem(24)};
    text-transform: uppercase;

    @media ${props => props.theme.breakpoints.smallHomeScreen} {
      height: ${rem(38)};
      width: 100%;
      padding-right: 0;
    }
    @media ${props => props.theme.breakpoints.largeHomeScreen} {
      height: ${rem(38)};
      width: 100%;
      padding-right: 0;
    }
  }
`;

export const AppLinks = styled.div.withConfig({ displayName: "AppLinks" })`
  width: auto;
  padding-top: ${rem(5)};

  @media ${props => props.theme.breakpoints.smallHomeScreen} {
    align-self: start;
  }
  @media ${props => props.theme.breakpoints.largeHomeScreen} {
    align-self: start;
  }
`;

export const AppStore = styled.img.withConfig({ displayName: "AppStore" })`
  width: ${rem(122)};
`;

export const GooglePlay = styled.img.withConfig({ displayName: "GooglePlay" })`
  width: ${rem(135)};
  margin-right: ${rem(8)};
`;

export const FooterContainerLastBlock = styled.div.withConfig({
  displayName: "FooterContainerLastBlock",
})`
  display: flex;
  width: 100%;
  height: 5rem;
  flex-direction: row;
  align-items: center;
  padding: ${rem(20)} ${rem(10)} ${rem(20)} ${rem(40)};

  @media ${props => props.theme.breakpoints.smallHomeScreen} {
    width: 100%;
    height: 12rem;
    flex-direction: column;
    padding: ${rem(20)} ${rem(20)};
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  @media ${props => props.theme.breakpoints.largeHomeScreen} {
    width: 100%;
    height: 12rem;
    padding: ${rem(20)} ${rem(20)};
    flex-direction: column;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  p {
    height: ${rem(48)};
    width: ${rem(130)};
    display: flex;
    color: ${props => props.theme.baseColor};
    font-size: ${em(20)};
    text-align: start;
    font-weight: bold;
    line-height: ${rem(24)};
    text-transform: uppercase;

    @media ${props => props.theme.breakpoints.smallHomeScreen} {
      height: ${rem(38)};
      width: 100%;
      padding-right: 0;
    }
    @media ${props => props.theme.breakpoints.largeHomeScreen} {
      height: ${rem(38)};
      width: 100%;
      padding-right: 0;
    }
  }
`;

export const FooterContainerPolicyBlock = styled.div.withConfig({
  displayName: "FooterContainerPolicyBlock",
})`
  background-color: #010000;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${rem(30)} ${rem(10)};
`;

export const FooterList = styled.div.withConfig({ displayName: "FooterList" })`
  width: auto;
  display: flex;
  font-family: "Roboto";
  align-self: center;
  flex-wrap: wrap;
  flex-direction: row;
  padding-left: ${rem(20)};
  justify-content: flex-start;
  align-items: center;
  gap: ${rem(20)};

  @media ${props => props.theme.breakpoints.smallHomeScreen} {
    padding-left: 0;
  }
  @media ${props => props.theme.breakpoints.largeHomeScreen} {
    padding-left: 0;
  }
`;

export const PolicyList = styled.div.withConfig({ displayName: "PolicyList" })`
  display: flex;
  gap: ${rem(45)};
  width: auto;
  text-align: left;
  justify-content: center;
  text-decoration: underline;
  font-size: ${em(14)};
  opacity: 0.8;

  @media ${props => props.theme.breakpoints.smallHomeScreen} {
    justify-content: space-around;
    gap: ${rem(25)};
  }
  @media ${props => props.theme.breakpoints.largeHomeScreen} {
    justify-content: space-around;
    gap: ${rem(25)};
  }

  a {
    width: ${rem(160)};
    font-weight: lighter;
    color: ${props => props.theme.baseColor};

    @media ${props => props.theme.breakpoints.smallHomeScreen} {
      width: ${rem(85)};
    }
    @media ${props => props.theme.breakpoints.largeHomeScreen} {
      width: ${rem(85)};
    }
  }
`;

export const ListItem = styled.div.withConfig({ displayName: "ListItem" })`
  display: flex;
  align-items: center;
  width: ${rem(120)};

  img {
    width: ${rem(20)};
    height: ${rem(22)};
  }

  span {
    margin-left: ${rem(10)};
    color: ${props => props.theme.baseColor};
    font-size: ${em(12)};
    font-weight: bold;
    text-align: left;
    opacity: 0.8;
  }
`;

export const ClaroPay = styled.img.withConfig({ displayName: "ClaroPay" })`
  width: ${rem(65)};
  margin-bottom: ${rem(3)};
  margin-left: ${rem(3)};
`;

export const DivisionFooter = styled.div.withConfig({ displayName: "DivisionFooter" })`
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    height: 1px;
    background-color: #010000;
  }
`;

export const DivisionFooterBar = styled.div.withConfig({ displayName: "DivisionFooterBar" })`
  @media (min-width: 768px) {
    display: flex;
    width: 85%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
  }
`;
